const uploadDefaultState = {
  docToQuizNewPresentationRequestId: null,
  docToQuizGlobalImportError: false,
  docToQuizTrackGenerationDone: false,

  // UPLOAD IMAGE
  uploadLocalImageError: null,
  isUploadingLocalImage: false,
  isUploadImageModalVisible: false,
}

export default uploadDefaultState
